export const RC_NOTIFY_USER = 'stream-notify-user';
export const RC_NOTIFY_ROOM = 'stream-notify-room';
export const RC_NOTIFY_ROOM_MESSAGE = 'stream-room-messages';

export const RC_CHECK_STATE_STEP = 40000;

export const RC_ERROR_INVALID_USER = 'error-invalid-user';

export const RC_USER_PREFIX_FP = 'customer_';
export const RC_USER_PREFIX_T = 'device_user_';

export const RC_MESSAGE_NUMBER = 50;

export const RC_SUBSCRIPTION_TYPING = '/typing';
export const RC_SUBSCRIPTION_MESSAGE = '/message';
export const RC_SUBSCRIPTION_NOTIFICATION = '/notification';

export const RC_STATUS_ONLINE = 'online';
export const RC_STATUS_OFFLINE = 'offline';
export const RC_STATUS_BUSY = 'busy';
export const RC_STATUS_AWAY = 'away';

export const RC_MESSAGE_DIRECT_TYPE = 'd';

export const RC_MSG_RESPONSE_PING = 'ping';
export const RC_MSG_RESPONSE_ERROR = 'error';
export const RC_MSG_RESPONSE_ADDED = 'added';
export const RC_MSG_RESPONSE_REMOVED = 'removed';
export const RC_MSG_RESPONSE_CHANGED = 'changed';
export const RC_MSG_RESPONSE_RESULT = 'result';
export const RC_MSG_RESPONSE_NOSUB = 'nosub';

export const RC_MSG_REQUEST_CONNECT = 'connect';
export const RC_MSG_REQUEST_PONG = 'pong';
export const RC_MSG_REQUEST_SUBSCRIBE = 'sub';
export const RC_MSG_REQUEST_METHOD = 'method';

export const RC_METHOD_DIRECT_MESSAGE = "createDirectMessage";
export const RC_METHOD_SEND_MESSAGE = "sendMessage";
export const RC_METHOD_READ_MESSAGES = "readMessages";
export const RC_METHOD_HISTORY = "loadHistory";
export const RC_METHOD_SUBSCRIPTIONS = "subscriptions/get";
export const RC_METHOD_LOGIN = "login";
export const RC_METHOD_USER_ROLES = "getUserRoles";
